import { ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { Link } from "react-router-dom";

export const HeroSection = () => {
  return (
    <section className="relative py-20 overflow-hidden bg-gradient-to-b from-blue-50 to-white">
      <div className="absolute inset-0 bg-grid-blue-100/50 bg-grid-16 [mask-image:radial-gradient(white,transparent_85%)]" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 animate-fade-in">
            Transform Your Business with{" "}
            <span className="text-blue-600">Intelligent Automation</span>
          </h1>
          <p className="text-xl text-gray-600 mb-8 animate-fade-in">
            Streamline your workflows, eliminate repetitive tasks, and boost productivity with our AI-powered automation solutions. By leveraging tools like Zapier, Make.com, and intelligent AI integrations, we create smarter, faster, and more efficient workflows that adapt to your business needs.
          </p>
          <div className="flex justify-center gap-4">
            <Link to="/contact">
              <Button size="lg" className="animate-fade-in">
                Get Started <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};